var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast"},[_c('div',{staticClass:"center"},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/images/index/open.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v("请使用微信扫码打开")])])])
}]

export { render, staticRenderFns }